/* Mega menu propio de Sirena (reemplaza Meteor). Markup y estilos: snippets/sirena-mega-menu.liquid */
(function () {
  var root = document.querySelector('.smm');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var canHover = window.matchMedia('(hover: hover)').matches;
  var openLi = null, openedAt = 0, tOpen, tClose;

  function panelOf(li) { return li.querySelector('[data-smm-panel]'); }
  function toggleOf(li) { return li.querySelector('[data-smm-toggle]'); }
  function open(li) {
    if (openLi === li) return;
    close(openLi);
    openLi = li; openedAt = Date.now();
    li.classList.add('is-open');
    toggleOf(li).setAttribute('aria-expanded', 'true');
    panelOf(li).hidden = false;
  }
  function close(li) {
    if (!li) return;
    li.classList.remove('is-open');
    toggleOf(li).setAttribute('aria-expanded', 'false');
    panelOf(li).hidden = true;
    if (openLi === li) openLi = null;
  }

  root.querySelectorAll('.smm__item--parent').forEach(function (li) {
    var a = toggleOf(li);
    li.addEventListener('mouseenter', function () {
      clearTimeout(tClose);
      tOpen = setTimeout(function () { open(li); }, openLi ? 0 : 110);
    });
    li.addEventListener('mouseleave', function () {
      clearTimeout(tOpen);
      tClose = setTimeout(function () { close(li); }, 200);
    });
    a.addEventListener('click', function (e) {
      var isHash = a.getAttribute('href') === '#';
      if (!li.classList.contains('is-open')) { e.preventDefault(); open(li); return; }
      if (isHash) {
        e.preventDefault();
        /* Con mouse el hover ya lo abrio: un clic no lo cierra. En pantallas tactiles, si. */
        if (!canHover && Date.now() - openedAt > 350) close(li);
      }
    });

    var deps = li.querySelectorAll('[data-smm-dep]');
    deps.forEach(function (d) {
      function activate() {
        var pane = li.querySelector('[data-smm-pane="' + d.getAttribute('data-smm-dep') + '"]');
        if (!pane) return;
        li.querySelectorAll('[data-smm-pane]').forEach(function (p) { p.hidden = (p !== pane); });
        deps.forEach(function (x) { x.classList.toggle('is-active', x === d); });
      }
      d.addEventListener('mouseenter', activate);
      d.addEventListener('focus', activate);
      /* Departamento sin pagina propia (#): el clic solo muestra sus subcategorias.
         En pantallas tactiles el primer toque muestra las subcategorias; el segundo entra. */
      d.addEventListener('click', function (e) {
        if (d.getAttribute('href') === '#' || (!canHover && !d.classList.contains('is-active'))) { e.preventDefault(); activate(); }
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLi) { var a = toggleOf(openLi); close(openLi); a.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (openLi && !openLi.contains(e.target)) close(openLi);
  });
  root.addEventListener('focusin', function (e) {
    var li = e.target.closest('.smm__item--parent');
    if (li) open(li); else close(openLi);
  });
})();
